import { render, staticRenderFns } from "./PluginGoogleTagManager.vue?vue&type=template&id=6a3a5f1a"
import script from "./PluginGoogleTagManager.vue?vue&type=script&lang=js"
export * from "./PluginGoogleTagManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3a5f1a')) {
      api.createRecord('6a3a5f1a', component.options)
    } else {
      api.reload('6a3a5f1a', component.options)
    }
    module.hot.accept("./PluginGoogleTagManager.vue?vue&type=template&id=6a3a5f1a", function () {
      api.rerender('6a3a5f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginGoogleTagManager.vue"
export default component.exports